import { cva } from 'class-variance-authority'

export const popoverContentStyles = cva(
  `
    w-72 
    rounded-lg
    border-1 
    border-neutral-200
    bg-popover 
    p-4 
    z-2000
    text-popover-foreground 
    shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.10),0px_2px_4px_-1px_rgba(0,0,0,0.06)]
    max-h-[var(--radix-popover-content-available-height)]
    w-[var(--radix-popover-trigger-width)]
    overflow-y-auto
    outline-none 
    bg-neutral-0
    min-w-[250px]
    data-[state=open]:animate-in 
    data-[state=closed]:animate-out 
    data-[state=closed]:fade-out-0 
    data-[state=open]:fade-in-0 
    data-[state=closed]:zoom-out-95 
    data-[state=open]:zoom-in-95 
    data-[side=bottom]:slide-in-from-top-2 
    data-[side=left]:slide-in-from-right-2 
    data-[side=right]:slide-in-from-left-2 
    data-[side=top]:slide-in-from-bottom-2
  `
)
